export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '';
export const email = 'an.lazar@andersenlab.com';

export const meetupDate = '2026-06-09';
export const meetupStartTime = '17:00';
export const timeZone = 'GMT+1';
